<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>素材管理 > <b>默认组件</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
            <span class="search_span_width">
                <span class="search_span_width_part1">背景类型：</span>
				<Select v-model="search.mat_type"  style="width:200px">
				        <Option value="1">图片背景</Option>
				        <Option value="2">视频背景</Option>
				    </Select>
				</FormItem>
            </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getUnitList()">搜索</Button>
      </Card>
      <Card>
       <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
			<span :style="{'text-align':'center','float':'left'}">
				<Button type='primary' :style="{'margin-left':'5px'}" @click="addMaterialModal()">添加素材</Button>
			</span>
        </p>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="unit_list"></Table>
		  <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getUnitList"/>
        </Card>
      </Card>
    </Content>
   
	<Modal v-model="showeditmodal" :footer-hide=true title="组件">
	     <Form ref="unit" :model="unit" :label-width="80" :rules="unitRule">
	         <FormItem label="类型" prop="mat_type">
					<RadioGroup v-model="unit.mat_type">
				        <Radio label="1">图片背景</Radio>
				        <Radio label="2">视频背景</Radio>
				    </RadioGroup>
				</FormItem>
				<FormItem label="横竖屏" prop="screen">
				 <Select v-model="unit.screen"  style="width:200px">
				        <Option value="0">全部适用</Option>
				        <Option value="1">横屏</Option>
				        <Option value="2">竖屏</Option>
				    </Select>
				</FormItem>
	         <FormItem label="名称" prop="name">
	             <Input v-model="unit.name"  />
	         </FormItem>
         <FormItem label="英文名称" prop="en_name">
           <Input v-model="unit.en_name"  />
         </FormItem>
				<FormItem label="排序" prop="seq">
				    <Input v-model="unit.seq"  />
				</FormItem>
				<FormItem label="素材" prop="mat_url">
					<a :href="unit.mat_url" v-show="unit.mat_url?true:false" target="_blank">链接</a>
				    <Upload :action="getUploadUrl" :data="upload_data" :headers="uploadHeader" :on-success="successUpload">
				        <Button icon="ios-cloud-upload-outline">上传素材</Button>
				    </Upload>
				</FormItem>  
	         <FormItem>
	             <Button type="primary" @click="updateUnit()">提交</Button>
	         </FormItem>
	     </Form>
	 </Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
			mat_type:''
		},
		file_dir : 'default',
		showeditmodal:false,
		unit_list:[],
		page:1,
		recordTotal:0,
		unit:{
			id:0,
			name:'',
      en_name:'',
			url:'',
			unit_type:1,
			mat_type:1,
			mat_url:'',
			screen:0,
			seq:0,
			mat_id:0
		},
		upload_data:{
			file:'',
			unit_type:1,
			mat_type:1,
			file_dir :'default'
		},
		unitRule: {
		  mat_type: [{ required: true, message: "请选择类型", trigger: "blur" }],
		  screen: [ { required: true, message: "请选择横竖屏", trigger: "blur" }],
		  name: [ { required: true, message: "请输入名称", trigger: "blur" }],
		  //mat_url: [ { required: true, message: "请上传素材", trigger: "blur" }],
		},
		tableColumns:[
		{ title: '组件ID', key: 'id', align: 'center' },
		{ title: '名称', key: 'name', align: 'center' },
      { title: '英文名称', key: 'en_name', align: 'center' },
		{ title: '类型', key: 'mat_type', align: 'center',
		 render:(h,params) =>{
		    return h('span',{},params.row.mat_type == 1 ? "图片背景" : '视频背景');
			},
		 },
		{ title: '素材', key: 'attr',
			render:(h,params) =>{
			   return h('img',{
				 attrs : {
					src : params.row.attr.cover
				 },
				 style : {
				   width : '80px',
				   height : '80px'
				 }
			   })
			}
		 },
		 { title: '排序', key: 'seq', align: 'center' },
		{ title: '操作', key: 'action', align: 'center',
		  render: (h, params) => {
			let btns=[]
			btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {      
						this.unit.id = params.row.id;
						this.unit.mat_type = params.row.mat_type;
						this.unit.seq = params.row.seq;
						this.unit.name = params.row.name;
            this.unit.en_name = params.row.en_name;
						this.unit.screen = params.row.screen;
						this.unit.mat_url = params.row.attr.mat_url;
						this.unit.mat_id = params.row.attr.mat_id;
						this.showeditmodal = true;
					}
				  }
				}, '编辑'),
			);
			return h("div",btns);
		  }
		}
		],
		uploadHeader:{
		  "Authorization":localStorage.getItem('token')
		}
	}
  },
  mounted:function(){
    this.getUnitList();
  },
  computed:{
	getUploadUrl(){
	      return process.env.VUE_APP_APIHOST+'/admin/material/uploadPic';
	}
  },
  methods:{
	addMaterialModal(){
	  this.unit.id = 0;
	  this.unit.mat_id = 0;
	  this.unit.mat_type = 1;
	  this.unit.mat_url = '';
	  this.unit.name = '';
    this.unit.en_name = '';
	  this.unit.screen = 0;
	  this.unit.unit_type = 1;
	  this.unit.seq = 0;
	  this.showeditmodal = true;
	},
	getUnitList(page=1) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search,p);
		this.http.get('/admin/material/defaultUnitList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.unit_list = data.data.list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	updateUnit(){
		this.$refs["unit"].validate((valid) => {
		  if (valid) {
			  this.http.post('/admin/material/editUnit',{
			  		  'id':this.unit.id,
			  		  'name':this.unit.name,
			  		  'mat_type':this.unit.mat_type,
			  		  'seq':this.unit.seq,
			  		  'unit_type':this.unit.unit_type,
			  		  'screen':this.unit.screen,
			  		  'mat_id':this.unit.mat_id,
          'en_name':this.unit.en_name
			  		  }).then(response=>{
			    let data=response.data;
			    if(data.code!==0) {
			      this.$Message.error(data.message);
			      return false;
			    } else{
			      this.$Message.info(data.message);
			      this.showeditmodal = false;
			  	this.getUnitList(this.page);
			      return true;
			    }
			  });
			}
		});
		
	},
	successUpload(response, file, fileList){
	    let data=response
	    if(data.code!=0){
	        this.$Message.error(data.message);
	        return true;
	    }
	    this.unit.mat_id=data.data.mat_id;
		this.unit.mat_url = data.data.mat_url;
	},
    closeModal(){
		this.unit.id = 0;
		this.unit.mat_type = 0;
		this.unit.mat_id = 0;
		this.unit.seq = 0;
		this.unit.name = '';
      this.unit.en_name = '';
		this.unit.mat_url = '';
		this.showeditmodal = false;
    }
  }

}
</script>
